import RejectReasonAdvancedForm from './RejectReasonAdvancedForm'

export default RejectReasonAdvancedForm
